import type { IntentType } from "@/types/ab-tests";

/** Preset intent labels for create-test UI (aligned with backend copy). */
export const intentTypes: IntentType[] = [
  "Benefit-led",
  "Product-type-first",
  "Ingredient-led",
  "Use-case-first",
  "Emotional-benefit",
  "Functional-benefit",
  "Problem-solution",
  "Descriptor-framing",
  "Branded-lead",
  "Unbranded-lead",
  "Single-intent",
  "Dual-intent",
  "Short-form",
  "Long-form",
];
